import { useQuery } from '@tanstack/react-query';
import { getTailscaleGateways } from '../api';

export const tailscaleKeys = {
  gateways: ['tailscale', 'gateways'] as const,
};

// staleTime matches the backend's 30s Headscale cache — polling faster would
// only re-serve the same cached payload. The endpoint is full-admin only, so
// keep the query disabled for everyone else.
export function useTailscaleGateways(enabled = true) {
  return useQuery({
    queryKey: tailscaleKeys.gateways,
    queryFn: getTailscaleGateways,
    enabled,
    staleTime: 30 * 1000,
    retry: 1,
  });
}
